import axios from 'axios';
import { useState, useEffect } from 'react'
import "../../Assets/Styles/Form/customerForm.scss";
import "../../Assets/Styles/selectSearch.scss";
import SubmitBtn from '../Buttons/submitBtn';
import RegisterBtns from '../Buttons/registerBtns';
import ReactModal from './../Modals/index';
import BanquetReservation from './banquetReservation';
import { useNavigate, useSearchParams } from 'react-router-dom';

const CustomerInfo = () => {
    let baseUrl = process.env.REACT_APP_BASE_URL;
    let navigate = useNavigate();

    const [showBanquet, setshowBanquet] = useState(false)
    const [customerID, setCustomerID] = useState("")
    const [isDisabled, setIsDisabled] = useState(true);
    const [isVerified, setIsVerified] = useState(false);
    const [verifiedCustomer, setVerifiedCustomer] = useState({});
    const [checkError, setCheckError] = useState(false);
    const [message, setMessage] = useState("");
    const [token, setToken] = useState("");
    const [inquiryData, setInquiryData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    const [customerList, setCustomerList] = useState([]);
    const [searchParams] = useSearchParams();

    useEffect(() => {
        let tokenCheck = localStorage.getItem("tokens");
        if (!tokenCheck) {
            navigate('/')
        } else {
            setToken(localStorage.getItem("tokens"))
        }
    }, [])

    const [values, setValues] = useState({
        fullName: "",
        phone: "",
        altPhone: "",
        email: "",
        address: "",
        country: "",
        type: "Individual",
        panNumber: ""
    });

    const handleInputChange = (e) => {
        const { id, value } = e.target;
        setValues({
            ...values,
            [id]: value,
        });
    }

    useEffect(() => {
        if (token) {
            axios.post(`${baseUrl}/customerNameList`, {
                token: `${token}`
            })
                .then((response) => {
                    setCustomerList(response.data)
                })
                .catch((error) => {
                    // console.log(error)
                })
        }
    }, [token])

    useEffect(() => {
        const isInquiry = searchParams.get('is_inquiry') === 'true';

        if (isInquiry) {
            setValues(prev => ({
                ...prev,
                fullName: searchParams.get('customer_name'),
                phone: searchParams.get('contact_no'),
                email: searchParams.get('email'),
                _inquiryData: {
                    address: searchParams.get('address'),
                    country: searchParams.get('country'),
                    panNo: searchParams.get('pan_no')
                }
            }));

            const data = {
                hallName: searchParams.get('hallname'),
                timeSlot: searchParams.get('timeslot'),
                reservationDate: searchParams.get('reservation_date'),
                reservationMiti: searchParams.get('reservation_miti'),
                inquiry_id: searchParams.get('id')
            };
            setInquiryData(data);
        }
        setIsLoading(false);
    }, [searchParams]);

    const handleVerify = () => {
        axios.post(`${baseUrl}/customercheck`, {
            token: `${token}`,
            Name: values.fullName,
            Email: values.email,
            Phone: values.phone,
        })
            .then((response) => {
                const customerData = response.data.success[0];
                setIsVerified(true);
                setVerifiedCustomer(customerData);
                setCustomerID(customerData.customerId);
                setIsDisabled(false);
                setshowBanquet(true);
                setCheckError(false);

                setValues(prev => ({
                    ...prev,
                    address: customerData.address || '',
                    country: customerData.country || '',
                    type: customerData.type || 'Individual',
                    panNumber: customerData.vatno || '',
                    altPhone: customerData.altPhone || ''
                }));
            })
            .catch((error) => {
                setIsVerified(false);
                setIsDisabled(false);
                setCheckError(true);
                handleShow();
                setMessage(error.response.data.error);

                if (values._inquiryData) {
                    setValues(prev => ({
                        ...prev,
                        address: prev._inquiryData.address || '',
                        country: prev._inquiryData.country || '',
                    }));
                }
            });
    };

    const handleReset = () => {
        setVerifiedCustomer({})
        setValues({
            fullName: "",
            phone: "",
            email: "",
            address: "",
            country: "",
            type: "Individual",
            panNumber: ""
        })
        // for (let prop in verifiedCustomer) {
        //     delete verifiedCustomer[prop];
        //   }
    }

    //Handle Modal open and close
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleCustomer = () => {
        axios.post(`${baseUrl}/customerpost`, {
            token: `${token}`,
            // Name: selectedCustomer,
            Name: values.fullName,
            Email: values.email,
            Phone: values.phone,
            altPhone: values.altPhone,
            Address: values.address,
            Country: values.country,
            type: values.type,
            cardno: "",
            vatno: values.panNumber,
        })
            .then((response) => {
                // console.log("res123", response.data)
                // console.log("customerpost res123", response.data.success)
                setMessage("Congratulation! You have registered successfully")
                setCustomerID(response.data.success)
                setshowBanquet(true)
                handleShow();
                setCheckError(false)

            })
            .catch((error) => {
                // console.log("customerpost err", error.response.data)
                handleShow()
                setCheckError(true)
                setshowBanquet(true)
                setMessage(error.response.data.error)
            })
    }

    return (
        <div>
            <ReactModal
                show={show}
                handleClose={handleClose}
                message={message}
                buttonOne={"OK"}
                buttonTwo={"Close"}
                handleTarget={handleClose}
            />
            <section className='customer'>
                <h5>Customer Information</h5>
                <div className='row customer-info'>
                    <div className='customer-info-input col-lg-3 col-md-4 col-sm-6'>
                        <label>Name</label>
                        <div>
                            {/* <SelectSearchInput defaultName={selectedCustomer} List={customerList} text={"Search Name"} setSelectedItem={setSelectedCustomer} />
                            <p>If not a user?</p> */}
                            <input type='text' name='name' id="fullName" value={values.fullName} placeholder='Ram Shrestha' onChange={handleInputChange} />
                        </div>
                    </div>
                    <div className='customer-info-input col-lg-3 col-md-4 col-sm-6'>
                        <label>Phone</label>
                        <div>
                            <input type='text' name='phone' id="phone" value={values.phone} placeholder='984113556' onChange={handleInputChange} />
                        </div>
                    </div>
                    <div className='customer-info-input col-lg-3 col-md-4 col-sm-6'>
                        <label>Second Phone No. </label>
                        <div>
                            <input type='text' name='altPhone' id="altPhone" value={values.altPhone} placeholder='9841522231' onChange={handleInputChange} />
                        </div>
                    </div>
                    <div className='customer-info-input col-lg-3 col-md-4 col-sm-6'>
                        <label>Email</label>
                        <div>
                            <input type='text' name='email' id="email" value={values.email} placeholder='example@gmail.com' onChange={handleInputChange} />
                        </div>
                    </div>
                    <div className='customer-info-input col-lg-3 col-md-4 col-sm-6'>
                        <label>Address</label>
                        <div>
                            <input
                                type='text'
                                id='address'
                                placeholder='kalinchok'
                                value={isVerified ? verifiedCustomer.address : values.address}
                                disabled={isVerified}
                                onChange={handleInputChange}
                            />
                        </div>
                    </div>
                    <div className='customer-info-input col-lg-3 col-md-4 col-sm-6'>
                        <label>Country</label>
                        <div>
                            <input
                                type='text'
                                id='country'
                                placeholder='Nepal'
                                value={isVerified ? verifiedCustomer.country : values.country}
                                disabled={isVerified}
                                onChange={handleInputChange}
                            />
                        </div>
                    </div>
                    <div className='customer-info-input col-lg-3 col-md-4 col-sm-6'>
                        <label>Type</label>
                        {isVerified ?
                            <div className='radio-type'>
                                <div>
                                    <input type="radio"
                                        id="type"
                                        name="type"
                                        checked={(verifiedCustomer.type === "Individual") && "Individual"}
                                        // checked={verifiedCustomer.type}
                                        value={"Individual"}
                                        disabled={isDisabled}
                                        onChange={handleInputChange} />
                                    <label>Individual</label>
                                </div>
                                <div  >
                                    <input type="radio"
                                        id="type"
                                        name="type"
                                        checked={(verifiedCustomer.type === "Company") && "Company"}
                                        value={"Company"}
                                        disabled={isDisabled}
                                        onChange={handleInputChange} />
                                    <label>Company</label>
                                </div>
                            </div>
                            :
                            <div className='radio-type'>
                                <div>
                                    <input type="radio"
                                        id="type"
                                        name="type"
                                        // checked={(verifiedCustomer.type === "Individual") && "Individual"}
                                        // checked={verifiedCustomer.type}
                                        value={"Individual"}
                                        disabled={isDisabled}
                                        onChange={handleInputChange} />
                                    <label>Individual</label>
                                </div>
                                <div  >
                                    <input type="radio"
                                        id="type"
                                        name="type"
                                        // checked={(verifiedCustomer.type === "Company") && "Company"}
                                        value={"Company"}
                                        disabled={isDisabled}
                                        onChange={handleInputChange} />
                                    <label>Company</label>
                                </div>
                            </div>
                        }
                    </div>
                    <div className='customer-info-input col-lg-3 col-md-4 col-sm-6'>
                        <label>PAN no.</label>
                        <div>
                            <input type='text' id='panNumber' placeholder='122456778' value={isVerified ? verifiedCustomer.vatno : values.panNumber} onChange={handleInputChange} disabled={isDisabled} />
                        </div>
                    </div>

                    {!isVerified &&
                        <div className='customer-info-input col-lg-3 col-md-4 col-sm-6'>
                            <SubmitBtn event={"Verify"} handle={handleVerify} />
                        </div>
                    }
                </div>
            </section>
            <RegisterBtns handleCustomer={handleCustomer} handleReset={handleReset} isVerified={isVerified} />

            <div className={showBanquet ? 'after-registration' : 'before-registration'}>
                {!isLoading && showBanquet && (
                    <BanquetReservation
                        customerID={customerID}
                        token={token}
                        inquiryData={inquiryData}
                    />
                )}
            </div>
        </div>
    )
}

export default CustomerInfo